var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9304 30.6318C22.9301 31.0513 22.5106 32.2452 22.9624 33.2133L24.5435 36.5369C24.9953 37.4724 26.0924 37.8922 27.0604 37.4724C29.8032 36.3107 32.1588 34.7941 34.0304 32.9548C36.3214 30.7932 37.8703 28.3085 38.7093 25.5657C39.5482 22.7903 40 19.0153 40 14.2073V4.30095C40 3.2361 39.1288 2.36486 38.0639 2.36486H25.3825C24.3176 2.36486 23.4464 3.2361 23.4464 4.30095V16.9824C23.4464 18.0475 24.3176 18.9185 25.3825 18.9185H31.4489C31.3844 22.1779 30.61 24.7913 29.1901 26.76C28.0285 28.3405 26.286 29.6312 23.9304 30.6318Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14922 30.632C0.148905 31.0515 -0.27026 32.2454 0.181173 33.2135L1.76232 36.5045C2.21407 37.4403 3.31119 37.8598 4.27924 37.4403C6.98977 36.2786 9.3134 34.762 11.2169 32.955C13.5083 30.7608 15.0891 28.2761 15.9284 25.5333C16.7674 22.8231 17.1865 19.0474 17.1865 14.2072V4.30082C17.1865 3.23597 16.3153 2.36472 15.2504 2.36472H2.56902C1.50417 2.36472 0.632929 3.23597 0.632929 4.30082V16.9822C0.632929 18.0474 1.50417 18.9183 2.56902 18.9183H8.66771C8.60318 22.1777 7.82842 24.7911 6.40894 26.7598C5.24728 28.3406 3.5048 29.6314 1.14922 30.632Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightQuote);
export default __webpack_public_path__ + "static/media/right-quote.36e14026f711682f78db44467665656b.svg";
export { ForwardRef as ReactComponent };